import type { CSSProperties, ReactNode } from 'react';

/** design-system/06-Components/04-Surfaces-And-Cards.md — border, never a shadow as well. */
export function AppCard({
  children,
  padding = 'var(--space-4)',
  onClick,
  sx,
}: {
  children: ReactNode;
  padding?: string;
  onClick?: () => void;
  sx?: CSSProperties;
}) {
  const style: CSSProperties = {
    width: '100%',
    display: 'block',
    textAlign: 'left',
    background: 'var(--surface-raised)',
    border: '1px solid var(--border-default)',
    borderRadius: 'var(--radius-l)',
    padding,
    ...sx,
  };

  // A card that does something is a button, so it reaches the keyboard. A card that does not stays a
  // section, so it does not appear in the tab order pretending to be interactive.
  return onClick ? (
    <button type="button" onClick={onClick} style={{ ...style, cursor: 'pointer' }}>
      {children}
    </button>
  ) : (
    <section style={style}>{children}</section>
  );
}
